import script from "./control.vue?vue&type=script&setup=true&lang=js"
export * from "./control.vue?vue&type=script&setup=true&lang=js"

import "./control.vue?vue&type=style&index=0&id=de78850a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de78850a"]])

export default __exports__